



















































import { Vue, Component, Prop, Watch, Ref, Emit } from 'vue-property-decorator'
import SeletorDePessoa from '@/components/cliente/SeletorDePessoa.vue'
import { Cliente, Pessoa, Usuario, Venda } from '@/models'
import { Inject } from 'inversify-props'
import { extrairCnpjOuCpfDoCliente } from '@/shareds/cliente-shareds'
import AlertModule from '@/store/vuex/aplicacao/AlertModule'
import { ClienteServiceAdapter, EditarUmaVendaUseCase, VendaServiceAdapter } from '@/usecases'
import { validarCpfOuCnpj } from '@/shareds/utils'

@Component({
	components: {
		SeletorDePessoa,
	},
})
export default class DialogoDeEdicaoDeClienteDaVenda extends Vue {
	@Ref() campoDeCliente!: HTMLInputElement
	@Prop({ type: String }) idDaVenda?: string 
	@Prop({ type: String }) cnpjOuCpfInicial!: string | null
	@Prop({ type: Object }) representanteDaVenda!: Usuario | null

	@Inject('VendaServiceAdapter')
	private vendaService!: VendaServiceAdapter

	@Inject('ClienteServiceAdapter')
	private clienteService!: ClienteServiceAdapter

	mostra: boolean | null = null

	editarVendaUseCase = new EditarUmaVendaUseCase()

	cliente: Cliente | string | null = null
	salvando = false
	carregando = false

	@Watch('mostra')
	async onChangeMostra(mostra: boolean) {
		if (!mostra) return
		if (!this.cnpjOuCpfInicial) {
			this.cliente = null
			return
		}
		this.cliente = this.cnpjOuCpfInicial
		window.requestAnimationFrame(() => {
			this.campoDeCliente.focus()
		})
	}

	@Emit('update:cliente')
	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	inputCliente(cliente: Cliente | null){
		// do nothing.
	}

	@Emit('update:cpfDoCliente')
	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	inputCnpjOuCpf(cliente: string | null){
		// do nothing.
	}

	@Emit('update:representante')
	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	inputRepresentante(venda: Venda | null){
		// do nothing.
	}

	async getCliente(cpfOuCnpj: string) {
		try {
			return await this.clienteService.get(cpfOuCnpj);
		} catch(err) {
			return cpfOuCnpj
		}
	}

	async confirmar() {
		const cnpjOuCpf = extrairCnpjOuCpfDoCliente(this.cliente)
		const clienteDaVenda = this.cliente as Cliente

		if(!validarCpfOuCnpj(cnpjOuCpf)) {
			AlertModule.setError('CPF ou CNPJ inválido')
			return
		}
		
		if (this.idDaVenda) {
			try {
				this.salvando = true
				await this.vendaService.update(this.idDaVenda, {
					cpfDoCliente: cnpjOuCpf,
				})

				if (clienteDaVenda && clienteDaVenda.representanteComercial && clienteDaVenda.representanteComercial !== null 
				&& this.representanteDaVenda && this.representanteDaVenda !== null) {
					const clienteJaPossuiEsseRepresentante = clienteDaVenda.representanteComercial.id === this.representanteDaVenda.id
					if(!clienteJaPossuiEsseRepresentante) {
						const venda = await this.editarVendaUseCase.patchRepresentante(this.idDaVenda, clienteDaVenda.representanteComercial)
						this.inputRepresentante(typeof venda === 'object'
							? venda
							: null,
						)
					}
				}
			} catch (error) {
				AlertModule.setError(error)
				throw error
			} finally {
				this.salvando = false
			}
		}
		this.inputCliente(typeof this.cliente === 'object'
			? this.cliente
			: null,
		)
		this.inputCnpjOuCpf(cnpjOuCpf)
		this.mostra = false
	}

	async clienteSelecionadoitem(item: Pessoa | string) {
		this.cliente = typeof item === 'string' ? await this.getCliente(item): await this.getCliente(item.cnpjOuCpf) 
	}
}

